import context from './api';

export const sendFile = (file) => {
  const {
    incidentId,
    cardId,
    fileName,
    fileBody
  } = file;

  return context.file.set(incidentId, cardId, fileName, fileBody);
};

export const getFileList = (incidentId, cardId) => {
  return context.file.getList(incidentId, cardId);
};

export const getFile = (fileId) => {
  return context.file.getBody(fileId);
};